/**
 * Word cloud preset configurations
 * Ported from words_cloud_lib.coffee
 *
 * Preset format: [displayName, config, id]
 * Config: [scaleFunction, fontFamily, angles, colorsIndex, background, colorStyle, sizeRange, maxWords, orientation]
 */

import { THEME_BACKGROUND } from '@aytm/app/stats/page/question-views/components/word-cloud/constants/config'

export const PRESETS = [
  ['Central Park', ['sqrt', 'Alfa Slab One', [18, 288], 1, THEME_BACKGROUND, 'adj_levels', [5, 142], 131, 'v'], 'c'],
  ['NYC', ['sqrt', 'Alfa Slab One', [18, 288], 4, THEME_BACKGROUND, 'adj_levels', [5, 142], 131, 'h'], '3'],
  [
    'Cappuccino',
    ['pow9', 'Berkshire Swash', [0, 351, 5, 0], ['#e3daba', '#b3630e'], '#210f00', 'gradient', [5, 127], 335, 'v'],
    'l'
  ],
  [
    'Night Jungle',
    [
      'log',
      'Amatic SC',
      [293, 29, 0],
      ['#8CC63F', '#60AC66', '#419982', '#1D83A2', '#1868A6', '#135182', '#003863'],
      THEME_BACKGROUND,
      'adj_levels',
      [21, 70],
      256,
      'v'
    ],
    'm'
  ],
  ['Bookstore', ['sqrt', 'Alegreya SC', [345, 315, 349], 3, '#ffffff', 'adj_levels', [25, 105], 15, 'h'], '6'],
  [
    'Meltdown',
    [
      'sqrt',
      'Six Caps',
      [0, 270],
      ['#ffffff', '#FBB03B', '#F7931E', '#F15A24', '#ED1C24', '#C1272D', '#7a1727'],
      THEME_BACKGROUND,
      'adj_levels',
      [8, 140],
      412,
      'v'
    ],
    'a'
  ],
  [
    'Sterling silver',
    [
      'sqrt',
      'Cinzel Decorative',
      [357, 0, 355],
      ['#CCCCCC', '#B2B2B2', '#999999', '#808080', '#666666', '#4D4D4D', '#333333'],
      THEME_BACKGROUND,
      'adj_levels',
      [5, 75],
      767,
      'v'
    ],
    '9'
  ],
  [
    '3D pillow',
    [
      'pow3',
      'Six Caps',
      [342],
      ['#ff9d00', '#FBB03B', '#effc00', '#b9db1f', '#98c451', '#29ABE2', '#0b6da1'],
      THEME_BACKGROUND,
      'adj_levels',
      [12, 88],
      715,
      'v'
    ],
    'j'
  ],
  [
    'Goldmine',
    ['pow4', 'IM Fell DW Pica SC', [62, 22], ['#ffb700', '#210F03'], THEME_BACKGROUND, 'gradient', [5, 119], 548, 'v'],
    'd'
  ],
  [
    'Sequoia',
    ['sqrt', 'SaunaB', [80, 275, 268], ['#ff9f05', '#820202'], '#290b00', 'gradient', [5, 137], 548, 'v'],
    'e'
  ],
  [
    'Shoal of fish',
    [
      'sqrt',
      'Amatic SC',
      [324, 317],
      ['#8cdbff', '#7bc3f2', '#00a6ff', '#3898ff', '#207fc7', '#5281ba', '#146da1'],
      THEME_BACKGROUND,
      'adj_levels',
      [8, 140],
      412,
      'v'
    ],
    'b'
  ],
  ['Wool', ['sqrt', 'SegoeUIL', [0], 4, '#f7f8fa', 'adj_levels', [10, 100], 545, 'h'], '8'],
  [
    'College',
    [
      'pow9',
      'Alfa Slab One',
      [256, 113, 340, 332, 105],
      ['#404040', '#FBB03B', '#999999', '#8CC63F', '#666666', '#29ABE2', '#333333'],
      '#e8e6df',
      'adj_levels',
      [16, 95],
      83,
      'h'
    ],
    '4'
  ],
  ['Tsunami', ['sqrt', 'SaunaB', [18], 1, '#1b1b1c', 'adj_levels', [3, 150], 500, 'h'], '1'],
  [
    'Blackboard',
    [
      'pow6',
      'Gloria Hallelujah',
      [0],
      ['#ffffff', '#B2B2B2', '#999999', '#808080', '#666666', '#4D4D4D', '#333333'],
      THEME_BACKGROUND,
      'adj_levels',
      [18, 80],
      118,
      'h'
    ],
    'g'
  ],
  ['Lavender soap', ['sqrt', 'SaunaB', [5], ['#FFD1FF', '#9C229C'], '#011F30', 'gradient', [6, 71], 692, 'v'], 'f'],
  [
    'Fingerprint',
    [
      'sqrt',
      'Lobster',
      [317, 0],
      ['#aaeb1d', '#F7931E', '#FCD821', '#8CC63F', '#29ABE2', '#0071BC', '#007bff'],
      THEME_BACKGROUND,
      'adj_levels',
      [3, 119],
      391,
      'v'
    ],
    'k'
  ],
  [
    'Cardbox',
    [
      'pow6',
      'Permanent Marker',
      [0],
      ['#030303', '#000000', '#000000', '#000000', '#000000', '#000000', '#333333'],
      '#e3dfd3',
      'adj_levels',
      [18, 80],
      46,
      'h'
    ],
    'h'
  ],
  [
    'Poster',
    [
      'pow6',
      'Michroma',
      [317, 0],
      ['#ED1C24', '#F7931E', '#FCD821', '#8CC63F', '#29ABE2', '#0071BC', '#9E005D'],
      THEME_BACKGROUND,
      'adj_levels',
      [8, 148],
      84,
      'v'
    ],
    'i'
  ]
]

/**
 * The gradient stops a `colorStyle: 'gradient'` preset names by number, ported from the cloud lib.
 * Each row is `[[from, to], textColour]`; a preset only ever reads the stops.
 *
 * A preset's numeric palette for every other colour style is the report's own colour themes
 * (`COLOR_THEMES` in the shared colour lib) — see applyPreset.
 */
export const PRESET_GRADIENTS = [
  [['#8CC63F', '#003863'], THEME_BACKGROUND],
  [['#f4fad5', '#91cf00'], THEME_BACKGROUND],
  [['#00bbff', '#0081b0'], '#ffffff'],
  [['#FCD921', '#6E272D'], THEME_BACKGROUND],
  [['#ffe600', '#ff6600'], THEME_BACKGROUND],
  [['#d5aeeb', '#691c4a'], THEME_BACKGROUND],
  [['#CCCCCC', '#333333'], THEME_BACKGROUND]
]

/**
 * Get preset config by ID
 * @param {string} id - Preset ID (e.g., 'c', 'f', 's')
 * @returns {Object|null} Preset configuration or null if not found
 */
export function getPresetById(id) {
  const preset = PRESETS.find(p => p[2] === id)
  if (!preset) return null

  const [name, config] = preset
  const [scaleFunction, fontFamily, angles, colorsIndex, background, colorStyle, sizeRange, maxWords, orientation] =
    config

  return {
    name,
    id,
    scaleFunction,
    fontFamily,
    angles: [...angles],
    colorsIndex,
    background,
    colorStyle,
    rangeStart: sizeRange[0],
    rangeEnd: sizeRange[1],
    maxWords,
    orientation
  }
}

/**
 * Get preset config object from raw config array
 * @param {string} id - Preset ID
 * @returns {Object|null}
 */
export function getPresetConfig(id) {
  return getPresetById(id)
}

export default {
  PRESETS,
  getPresetById,
  getPresetConfig
}
